import { Lightroom } from "./Lightroom"

import { fabric } from 'fabric';

fabric.Image.filters.Mocha = fabric.util.createClass(fabric.Image.filters.Lightroom, {

  name: "Mocha",
  
  type: 'Mocha',

  initialize: function(options) {
    this.callSuper('initialize', options);
    
    this.whites = -20 
    this.blacks = -35 
    this.contrast = -7 
    this.exposure = -2.6 
    this.vibrance = -34 
    this.saturation = -37 
    this.highlights = -40 
    this.shadows = 11 
    this.temperature = 56 
    this.tint = 45 
    this.aquaSaturationAdjustment = -41 
    this.blueHueAdjustment = -14 
    this.redSaturationAdjustment = 3 
    this.redLuminanceAdjustment = -10 
    this.orangeHueAdjustment = -13 
    this.orangeSaturationAdjustment = -37 
    this.orangeLuminanceAdjustment = 12 
    this.yellowSaturationAdjustment = -2 
    this.greenSaturationAdjustment = -10 
    this.intensity = 1 
  },

});

fabric.Image.filters.Mocha.fromObject = fabric.Image.filters.Lightroom.fromObject;

const Mocha = fabric.Image.filters.Mocha

export { Mocha }
